import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, MapPin, Waves, Sun } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { destinations } from '../data/mock';

const DestinationDetailPage = () => {
  const { id } = useParams();
  const destination = destinations.find((d) => d.id === id);

  if (!destination) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Destination not found</h1>
          <Link to="/destinations" className="text-orange-500 hover:underline">
            Back to Destinations
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      
      {/* Hero Image */}
      <section className="relative h-[70vh] pt-20">
        <img
          src={destination.image}
          alt={destination.name}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-950/50 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8">
          <div className="max-w-7xl mx-auto">
            <Link
              to="/destinations"
              className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-4 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Destinations
            </Link>
            <span className="block text-orange-500 text-sm font-medium mb-2">{destination.tagline}</span>
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white">{destination.name}</h1>
          </div>
        </div>
      </section>

      {/* Details */}
      <section className="py-16 bg-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content */}
            <div className="lg:col-span-2">
              <h2 className="text-2xl font-serif font-bold text-white mb-4">About {destination.name}</h2>
              <p className="text-white/70 leading-relaxed mb-8">{destination.description}</p>
              
              {/* Highlights */}
              <div className="grid grid-cols-3 gap-4 mb-8">
                <div className="p-6 bg-gray-900 rounded-xl border border-gray-800">
                  <MapPin className="w-6 h-6 text-orange-500 mb-3" />
                  <p className="text-white/50 text-sm">Region</p>
                  <p className="text-white font-semibold">Southeast Asia</p>
                </div>
                <div className="p-6 bg-gray-900 rounded-xl border border-gray-800">
                  <Waves className="w-6 h-6 text-orange-500 mb-3" />
                  <p className="text-white/50 text-sm">Waters</p>
                  <p className="text-white font-semibold">Crystal Clear</p>
                </div>
                <div className="p-6 bg-gray-900 rounded-xl border border-gray-800">
                  <Sun className="w-6 h-6 text-orange-500 mb-3" />
                  <p className="text-white/50 text-sm">Climate</p>
                  <p className="text-white font-semibold">Tropical</p>
                </div>
              </div>
            </div>

            {/* Booking Card */}
            <div className="lg:col-span-1">
              <div className="sticky top-24 p-6 bg-gray-900 rounded-2xl border border-gray-800">
                <h3 className="text-xl font-semibold text-white mb-4">Plan Your Journey</h3>
                <p className="text-white/60 text-sm mb-6">
                  Experience the beauty of {destination.name} aboard one of our luxury yachts.
                </p>
                <Link
                  to="/booking"
                  className="block w-full py-4 bg-orange-500 text-white text-center font-medium rounded-lg hover:bg-orange-600 transition-colors"
                >
                  Start Planning
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DestinationDetailPage;
